.svg-container{height:50vh;width:100%;margin:0 auto;display:flex}.svg-container svg{height:100%;display:flex}
/*# sourceMappingURL=body-highlighter.component-UTAJN3VO.css.map */
